export default "__VITE_ASSET__DRfPomDh__"